import { Button } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import Image from 'next/image';
import React, { useMemo } from 'react';

import MaxWidth from '@/components/common/layout/MaxWidth';

import css from './SeasonalGuideSectionBannerBasic.module.css';
import { TSeasonalGuideSectionBannerBasic } from './types';

type TSeasonalGuideSectionBannerBasicProps = Omit<TSeasonalGuideSectionBannerBasic, 'type'>;

export const SeasonalGuideSectionBannerBasic = ({
  title,
  backgroundColor,
  textColor,
  items,
}: TSeasonalGuideSectionBannerBasicProps) => {
  const imagesMaxHeight = useMemo(() => {
    return items
      .map(item => ('src' in item.image ? item.image.height : 0))
      .reduce((a, b) => Math.max(a, b), 0);
  }, [items]);

  return (
    <MaxWidth className="mx-auto">
      <div
        className="flex flex-col px-6 py-8 lg:py-12 md:px-8 lg:px-12 xl:16 rounded-2xl gap-y-10"
        style={{ backgroundColor, color: textColor }}>
        <div className={cn('text-center', css.title)} dangerouslySetInnerHTML={{ __html: title }} />

        <div className={`grid grid-flow-row md:grid-cols-${items.length} gap-y-10 gap-x-20`}>
          {items.map((item, index) => (
            <div key={index} className="relative">
              <div
                className={cn('flex justify-center items-center mb-4', css.image)}
                style={{ height: imagesMaxHeight ? `${imagesMaxHeight}px` : 'auto' }}>
                {'svg' in item.image && (
                  <div className="flex items-center justify-center w-20 h-20">{item.image.svg}</div>
                )}

                {'src' in item.image && (
                  <Image
                    alt=""
                    src={item.image.src}
                    role="presentation"
                    width={item.image.width}
                    height={item.image.height}
                    placeholder={item.image.blurDataUrl ? 'blur' : 'empty'}
                    blurDataURL={item.image.blurDataUrl}
                    quality={45}
                  />
                )}
              </div>

              <div className="text-center">
                <Button
                  target="_blank"
                  rel="noreferrer"
                  href={item.linkUrl}
                  label={item.linkText}
                  className={cn('w-full md:w-auto', css.link)}
                />
              </div>

              {index > 0 && (
                <div className={cn('hidden md:block border-r absolute -ml-10', css.divider)} />
              )}
            </div>
          ))}
        </div>
      </div>
    </MaxWidth>
  );
};
